export default {
  data: [{
    id: 1,
    name: 'Premium',
    type: 'medium',
    price: 499,
    description: 'Advanced AI-powered site search for growing businesses.',
    buttonText: 'Select plan',
    productsAvailable: 40000,
  }, {
    id: 2,
    name: 'Professional',
    type: 'large',
    price: 799,
    description: '​For businesses with high volume, that are looking for a personalized experience across the store.',
    buttonText: 'Select plan',
    productsAvailable: 100000,
  }, {
    id: 3,
    name: 'Enterprise',
    type: 'enterprise',
    price: '1199+',
    description: 'Enjoy the ultimate level of Findify with the full suite of solutions, support, and account management.',
    buttonText: 'Select plan',
  }],
  tables: [{
    title: 'AI features',
    rows: [[
      'Personalized Site Search',
      'Personalized Site Search',
      'Personalized Site Search',
    ], [
      false,
      'Smart Collections',
      'Smart Collections',
    ],[
      false,
      false,
      'Personalized Recommendations',
    ]],
  }, {
    title: 'Usage',
    rows: [[
      'Up to 100,000 visits per month​',
      'Up to 200,000 visits per month ',
      'Custom visits',
    ], [
      'Up to 20,000 products',
      'Up to 50,000 products​',
      'Custom amount of products',
    ], [
      'One Store and language',
      'Multiple stores and languages',
      'Multiple stores and languages',
    ]],
    }
  ]
}
